/**
 * Resolves a value to an array, if it isn't already an array.
 * @template T
 * @param {T | readonly T[]} value
 * @returns {readonly T[]}
 */
var resolveToArray = function (value) {
    return Array.isArray(value) ? value : [value];
};
export default resolveToArray;
//# sourceMappingURL=resolveToArray.js.map